var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + _vm.level),{tag:"component",class:("title h" + (_vm.styleOf ? _vm.styleOf : _vm.level) + " " + _vm.variant + " " + _vm.site)},[_vm._t("default"),(_vm.content)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.content)))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }